import axios from '@/libs/api.request'
import { getToken } from "@/libs/util";
// 获取批量信息
export const getList = (params) => {
  return axios.request({
    url: '/warehouse/deliveryService',
    method: 'GET',
    params
  })
}
// 获取单个信息
export const getDetails = (id) => {
  return axios.request({
    url: `/warehouse/deliveryService/${id}`,
    method: 'GET'
  })
}
// 删除单个信息
export const del = (id) => {
  return axios.request({
    url: `/warehouse/deliveryService/${id}`,
    method: 'DELETE'
  })
}
// 修改单个信息
export const update = (data) => {
  return axios.request({
    url: `/warehouse/deliveryService/${data.id}`,
    method: 'PUT',
    data
  })
}
// 新增单个信息
export const add = (data) => {
  return axios.request({
    url: '/warehouse/deliveryService',
    method: 'POST',
    data
  })
}

export const uploadFile = data => {
  return axios.request({
    url: "/warehouse/deliveryService/uploadFile",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
};

export const b2bWarehouse = (id) => {
  return axios.request({
    url: `/common/b2bWarehouse`,
    method: 'GET'
  })
}

export const exportFun = data => {
  return axios.request({
    url: "/deliveryService/download",
    method: "post",
    data
  });
};
export const exportFun1 = data => {
  return axios.request({
    url: "/deliveryService/download1",
    method: "post",
    data
  });
};

export const addFile = data => {
  return axios.request({
    url: "/deliveryService/upload",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    }
  });
};

export const addFiles = data => {
  return axios.request({
    url: "/deliveryService/uploads",
    method: "post",
    data,
  });
};


export const excel = (data) => {
  return axios.request({
    url: `/tagService/excel`,
    method: 'POST',
    data,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    }
  })
}

export const src = (data) => {
  return axios.request({
    url: `/tagService/src`,
    method: 'POST',
    data,
  })
}

export const upload = (data) => {
  return axios.request({
    url: `/tagService/upload`,
    method: 'POST',
    data,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    }
  })
}


export const Del = (data) => {
  return axios.request({
    url: '/warehouse/deliveryService/delete',
    method: 'POST',
    data
  })
}

export const matchOrder = (data) => {
  return axios.request({
    url: '/deliveryService/matchOrder',
    method: 'POST',
    data
  })
}

export const batchDel = (data) => {
  return axios.request({
    url: '/warehouse/deliveryService/batchDelete',
    method: 'POST',
    data
  })
}

export const batchEditTime = (data) => {
  return axios.request({
    url: '/deliveryService/batchEditTime',
    method: 'POST',
    data
  })
}

export const saveWeight = (data) => {
  return axios.request({
    url: '/deliveryService/saveWeight',
    method: 'POST',
    data
  })
}

export const signProof = (data) => {
  return axios.request({
    url: '/deliveryService/signProof/' + data,
    method: 'GET',
    data
  })
}

export const pushECO = (data) => {
  return axios.request({
    url: '/v1/service/utilities/backend',
    method: 'POST',
    data
  })
}
